import React from "react";
import { Link } from "react-router-dom";
import { ClipboardList, PhoneCall, Users, GraduationCap, BadgePercent, ArrowRight } from "lucide-react";
import { PageHero } from "./Universita";

const STEPS = [
  { icon: ClipboardList, title: "Compila il form", desc: "Inserisci i tuoi dati e l'università d'interesse. Pochi minuti." },
  { icon: PhoneCall, title: "Ricevi contatto entro 48h", desc: "Un tutor del Polo ti chiamerà nei due giorni lavorativi successivi." },
  { icon: Users, title: "Parla con un esperto", desc: "Confronto gratuito: piano di studi, costi e tempistiche." },
  { icon: GraduationCap, title: "Scegli università e corso", desc: "Decidi con calma il percorso perfetto tra Pegaso, Mercatorum e San Raffaele." },
  { icon: BadgePercent, title: "Applichiamo la convenzione", desc: "Riduzione fino al -50% sulla retta e pagamento in comode rate." },
];

export default function Orientamento() {
  return (
    <div data-testid="page-orientamento">
      <PageHero
        eyebrow="Orientamento gratuito"
        title="5 passi verso la tua laurea."
        sub="Un percorso semplice e accompagnato dal nostro tutor. Senza impegno e senza costi."
      />

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="space-y-5">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={s.title} className="relative flex gap-5 lg:gap-8 items-start group" data-testid={`step-${i + 1}`}>
                  <div className="shrink-0 flex flex-col items-center">
                    <div className="w-14 h-14 rounded-2xl bg-brand-navy text-white flex items-center justify-center font-heading font-extrabold text-lg shadow-lg">
                      {i + 1}
                    </div>
                    {i < STEPS.length - 1 && <div className="w-px flex-1 bg-brand-line my-2 min-h-[60px]" />}
                  </div>
                  <div className="flex-1 pb-6 lg:pb-10">
                    <div className="rounded-2xl bg-brand-surface border border-brand-line p-6 lg:p-7 lift-card">
                      <div className="flex items-center gap-3 mb-2">
                        <Icon className="w-5 h-5 text-brand-emerald" />
                        <h3 className="font-heading font-extrabold text-xl text-brand-navy">{s.title}</h3>
                      </div>
                      <p className="text-brand-muted leading-relaxed">{s.desc}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-10 text-center">
            <Link to="/contatti" className="btn-primary text-base" data-testid="orientamento-cta">
              Richiedi Orientamento Gratuito <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
